import { createAxiosHttp } from "./createHttpRequest";

type IResult<T> = {
  code: number;
  message?: string;
  data: T
}

// 签署模板信息
type SignAgreementParams = {
  subjectCode: string;
  agreement: string;
  // 是否是医生签名
  judgment?: number;
}
type SignAgreementResult = {

}
export const signAgreement = (params: SignAgreementParams, fromDoctor=false)=> {
  return createAxiosHttp<IResult<SignAgreementResult>>({
    method: 'POST',
    url: 'plat/apply/subjectSign',
    data: {
      // 非必填做默认值
      judgment: fromDoctor ? 1 : 2,
      ...params,
    }
  })
}
